const PREFIX = "PERSISTENCE_";

export const ENABLE_PERSISTENCE_MIDDLEWARE = PREFIX + "ENABLE_PERSISTENCE_MIDDLEWARE"
export const LOAD_REDUX_STORE_FROM_LOCAL_STORAGE = PREFIX + "LOAD_REDUX_STORE_FROM_LOCAL_STORAGE";
export const LOAD_REDUX_STORE_FROM_LOCAL_STORAGE_CANCEL = PREFIX + "LOAD_REDUX_STORE_FROM_LOCAL_STORAGE_CANCEL";



// WEBPACK FOOTER //
// ./src/storeState/persistence/constant.js